import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import Drip from 'drip';
import { isProd, ajaxPreUrl } from '@/config/';
import { matchFeatureUrl } from '@/apis';
import { mtguardInit } from '../../utils/mtguard';
// 美团安全基线ab test
export function getMtGuardABtest() {
  return _getMtGuardABtest.apply(this, arguments);
}
function _getMtGuardABtest() {
  _getMtGuardABtest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var abtestResult, uuid, params;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (isProd) {
            _context4.next = 3;
            break;
          }
          mtguardInit();
          return _context4.abrupt("return");
        case 3:
          _context4.next = 5;
          return Drip.getStore('_mtguard_abtest_');
        case 5:
          abtestResult = _context4.sent;
          if (!(abtestResult !== undefined)) {
            _context4.next = 9;
            break;
          }
          if (abtestResult) {
            mtguardInit();
          }
          return _context4.abrupt("return");
        case 9:
          _context4.next = 11;
          return Drip.getUuid();
        case 11:
          uuid = _context4.sent;
          params = isProd ? {
            olapeId: 60,
            layerId: 190,
            filterId: uuid
          } : {
            olapeId: 536,
            layerId: 121,
            filterId: uuid
          };
          axios.get("".concat(ajaxPreUrl, "/getMatchedFeature"), {
            params: params
          }).then(function (_ref4) {
            var code = _ref4.code,
              data = _ref4.data;
            // 实验命中
            if (code === 200 && data) {
              mtguardInit();
            }
            Drip.setStore('_mtguard_abtest_', !!(code === 200 && data), {
              expires: '5M'
            });
          }).catch(function () {
            return {};
          });
        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getMtGuardABtest.apply(this, arguments);
}
var getABIdData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _Drip$constant$uaInfo, IS_MEITUAN, IS_MAOYAN, IS_DIANPING, myUUid, filterId, olapeId, layerId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _Drip$constant$uaInfo = Drip.constant.uaInfo, IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN, IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN, IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING;
          _context.next = 4;
          return Drip.getUuid();
        case 4:
          myUUid = _context.sent;
          filterId = myUUid;
          olapeId = 639;
          layerId = 0;
          if (IS_MEITUAN || IS_DIANPING) {
            layerId = 246;
          }
          if (IS_MAOYAN) {
            layerId = 245;
          }
          if (isProd) {
            olapeId = 84;
            if (IS_MEITUAN || IS_DIANPING) {
              layerId = 268;
            }
            if (IS_MAOYAN) {
              layerId = 267;
            }
          }
          return _context.abrupt("return", {
            olapeId: olapeId,
            layerId: layerId,
            filterId: filterId
          });
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", {});
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 14]]);
  }));
  return function getABIdData() {
    return _ref.apply(this, arguments);
  };
}();
export function getIsAbTest() {
  return _getIsAbTest.apply(this, arguments);
}
function _getIsAbTest() {
  _getIsAbTest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var url,
      _getABIdData,
      _Drip$constant$uaInfo3,
      IS_MEITUAN,
      IS_MAOYAN,
      IS_DIANPING,
      needRunABTest,
      _yield$_getABIdData,
      olapeId,
      layerId,
      filterId,
      _yield$axios$get,
      code,
      data,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          url = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : 'matchFeature';
          _getABIdData = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : getABIdData;
          _Drip$constant$uaInfo3 = Drip.constant.uaInfo, IS_MEITUAN = _Drip$constant$uaInfo3.IS_MEITUAN, IS_MAOYAN = _Drip$constant$uaInfo3.IS_MAOYAN, IS_DIANPING = _Drip$constant$uaInfo3.IS_DIANPING;
          needRunABTest = IS_MEITUAN || IS_MAOYAN || IS_DIANPING;
          if (needRunABTest) {
            _context5.next = 6;
            break;
          }
          return _context5.abrupt("return", false);
        case 6:
          _context5.prev = 6;
          _context5.next = 9;
          return _getABIdData();
        case 9:
          _yield$_getABIdData = _context5.sent;
          olapeId = _yield$_getABIdData.olapeId;
          layerId = _yield$_getABIdData.layerId;
          filterId = _yield$_getABIdData.filterId;
          _context5.next = 15;
          return axios.get("".concat(ajaxPreUrl, "/").concat(url, "?olapeId=").concat(olapeId, "&layerId=").concat(layerId, "&filterId=").concat(filterId), {
            timeout: 3000
          });
        case 15:
          _yield$axios$get = _context5.sent;
          code = _yield$axios$get.code;
          data = _yield$axios$get.data;
          if (!(code === 200)) {
            _context5.next = 20;
            break;
          }
          return _context5.abrupt("return", data);
        case 20:
          return _context5.abrupt("return", false);
        case 23:
          _context5.prev = 23;
          _context5.t0 = _context5["catch"](6);
          return _context5.abrupt("return", false);
        case 26:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[6, 23]]);
  }));
  return _getIsAbTest.apply(this, arguments);
}
var getABIdDataForUserBehavior = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _Drip$constant, _Drip$constant$uaInfo2, _Drip$constant2, _Drip$constant2$uaInf, _Drip$constant3, _Drip$constant3$uaInf, IS_MEITUAN, IS_MAOYAN, IS_DIANPING, myUUid, filterId, olapeId, layerId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          IS_MEITUAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : (_Drip$constant$uaInfo2 = _Drip$constant.uaInfo) === null || _Drip$constant$uaInfo2 === void 0 ? void 0 : _Drip$constant$uaInfo2.IS_MEITUAN) || false;
          IS_MAOYAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant2 = Drip.constant) === null || _Drip$constant2 === void 0 ? void 0 : (_Drip$constant2$uaInf = _Drip$constant2.uaInfo) === null || _Drip$constant2$uaInf === void 0 ? void 0 : _Drip$constant2$uaInf.IS_MAOYAN) || false;
          IS_DIANPING = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant3 = Drip.constant) === null || _Drip$constant3 === void 0 ? void 0 : (_Drip$constant3$uaInf = _Drip$constant3.uaInfo) === null || _Drip$constant3$uaInf === void 0 ? void 0 : _Drip$constant3$uaInf.IS_DIANPING) || false;
          _context2.next = 6;
          return Drip.getUuid();
        case 6:
          myUUid = _context2.sent;
          filterId = myUUid;
          olapeId = 647;
          layerId = 0;
          if (IS_MEITUAN || IS_DIANPING) {
            layerId = 258;
          }
          if (IS_MAOYAN) {
            layerId = 259;
          }
          if (isProd) {
            olapeId = 86;
            if (IS_MEITUAN || IS_DIANPING) {
              layerId = 281;
            }
            if (IS_MAOYAN) {
              layerId = 279;
            }
          }
          return _context2.abrupt("return", {
            olapeId: olapeId,
            layerId: layerId,
            filterId: filterId
          });
        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", {});
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 16]]);
  }));
  return function getABIdDataForUserBehavior() {
    return _ref2.apply(this, arguments);
  };
}();
export function getIsAbTestForUserBehavior() {
  return _getIsAbTestForUserBehavior.apply(this, arguments);
}
function _getIsAbTestForUserBehavior() {
  _getIsAbTestForUserBehavior = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _Drip$constant7, _Drip$constant7$uaInf, _Drip$constant8, _Drip$constant8$uaInf, _Drip$constant9, _Drip$constant9$uaInf;
    var url,
      _getABIdData,
      IS_MEITUAN,
      IS_MAOYAN,
      IS_DIANPING,
      needRunABTest,
      _yield$_getABIdData2,
      olapeId,
      layerId,
      filterId,
      _yield$axios$get2,
      code,
      data,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          url = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : 'matchFeature';
          _getABIdData = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : getABIdDataForUserBehavior;
          IS_MEITUAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant7 = Drip.constant) === null || _Drip$constant7 === void 0 ? void 0 : (_Drip$constant7$uaInf = _Drip$constant7.uaInfo) === null || _Drip$constant7$uaInf === void 0 ? void 0 : _Drip$constant7$uaInf.IS_MEITUAN) || false;
          IS_MAOYAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant8 = Drip.constant) === null || _Drip$constant8 === void 0 ? void 0 : (_Drip$constant8$uaInf = _Drip$constant8.uaInfo) === null || _Drip$constant8$uaInf === void 0 ? void 0 : _Drip$constant8$uaInf.IS_MAOYAN) || false;
          IS_DIANPING = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant9 = Drip.constant) === null || _Drip$constant9 === void 0 ? void 0 : (_Drip$constant9$uaInf = _Drip$constant9.uaInfo) === null || _Drip$constant9$uaInf === void 0 ? void 0 : _Drip$constant9$uaInf.IS_DIANPING) || false;
          needRunABTest = IS_MEITUAN || IS_MAOYAN || IS_DIANPING;
          if (needRunABTest) {
            _context6.next = 8;
            break;
          }
          return _context6.abrupt("return", false);
        case 8:
          _context6.prev = 8;
          _context6.next = 11;
          return _getABIdData();
        case 11:
          _yield$_getABIdData2 = _context6.sent;
          olapeId = _yield$_getABIdData2.olapeId;
          layerId = _yield$_getABIdData2.layerId;
          filterId = _yield$_getABIdData2.filterId;
          _context6.next = 17;
          return axios.get("".concat(ajaxPreUrl, "/").concat(url, "?olapeId=").concat(olapeId, "&layerId=").concat(layerId, "&filterId=").concat(filterId), {
            timeout: 3000
          });
        case 17:
          _yield$axios$get2 = _context6.sent;
          code = _yield$axios$get2.code;
          data = _yield$axios$get2.data;
          if (!(code === 200)) {
            _context6.next = 22;
            break;
          }
          return _context6.abrupt("return", data);
        case 22:
          return _context6.abrupt("return", false);
        case 25:
          _context6.prev = 25;
          _context6.t0 = _context6["catch"](8);
          return _context6.abrupt("return", false);
        case 28:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[8, 25]]);
  }));
  return _getIsAbTestForUserBehavior.apply(this, arguments);
}
var getABIdDataForLocalPerformance = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _Drip$constant4, _Drip$constant4$uaInf, _Drip$constant5, _Drip$constant5$uaInf, _Drip$constant6, _Drip$constant6$uaInf, IS_MEITUAN, IS_MAOYAN, IS_DIANPING, myUUid, filterId, olapeId, layerId;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          IS_MEITUAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant4 = Drip.constant) === null || _Drip$constant4 === void 0 ? void 0 : (_Drip$constant4$uaInf = _Drip$constant4.uaInfo) === null || _Drip$constant4$uaInf === void 0 ? void 0 : _Drip$constant4$uaInf.IS_MEITUAN) || false;
          IS_MAOYAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant5 = Drip.constant) === null || _Drip$constant5 === void 0 ? void 0 : (_Drip$constant5$uaInf = _Drip$constant5.uaInfo) === null || _Drip$constant5$uaInf === void 0 ? void 0 : _Drip$constant5$uaInf.IS_MAOYAN) || false;
          IS_DIANPING = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant6 = Drip.constant) === null || _Drip$constant6 === void 0 ? void 0 : (_Drip$constant6$uaInf = _Drip$constant6.uaInfo) === null || _Drip$constant6$uaInf === void 0 ? void 0 : _Drip$constant6$uaInf.IS_DIANPING) || false;
          _context3.next = 6;
          return Drip.getUuid();
        case 6:
          myUUid = _context3.sent;
          filterId = myUUid;
          olapeId = 648;
          layerId = 0;
          if (IS_MAOYAN) {
            layerId = 271;
          }
          if (IS_MEITUAN) {
            layerId = 273;
          }
          if (IS_DIANPING) {
            layerId = 274;
          }
          if (isProd) {
            olapeId = 88;
            if (IS_MAOYAN) {
              layerId = 290;
            }
            if (IS_MEITUAN) {
              layerId = 292;
            }
            if (IS_DIANPING) {
              layerId = 293;
            }
          }
          return _context3.abrupt("return", {
            olapeId: olapeId,
            layerId: layerId,
            filterId: filterId
          });
        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", {});
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 17]]);
  }));
  return function getABIdDataForLocalPerformance() {
    return _ref3.apply(this, arguments);
  };
}();
export function getABIdDataForLocalPerformancerBehavior() {
  return _getABIdDataForLocalPerformancerBehavior.apply(this, arguments);
}
function _getABIdDataForLocalPerformancerBehavior() {
  _getABIdDataForLocalPerformancerBehavior = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var _Drip$constant10, _Drip$constant10$uaIn, _Drip$constant11, _Drip$constant11$uaIn, _Drip$constant12, _Drip$constant12$uaIn;
    var url,
      _getABIdData,
      IS_MEITUAN,
      IS_MAOYAN,
      IS_DIANPING,
      needRunABTest,
      _yield$_getABIdData3,
      olapeId,
      layerId,
      filterId,
      _yield$axios$get3,
      code,
      data,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          url = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 'matchFeature';
          _getABIdData = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : getABIdDataForLocalPerformance;
          IS_MEITUAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant10 = Drip.constant) === null || _Drip$constant10 === void 0 ? void 0 : (_Drip$constant10$uaIn = _Drip$constant10.uaInfo) === null || _Drip$constant10$uaIn === void 0 ? void 0 : _Drip$constant10$uaIn.IS_MEITUAN) || false;
          IS_MAOYAN = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant11 = Drip.constant) === null || _Drip$constant11 === void 0 ? void 0 : (_Drip$constant11$uaIn = _Drip$constant11.uaInfo) === null || _Drip$constant11$uaIn === void 0 ? void 0 : _Drip$constant11$uaIn.IS_MAOYAN) || false;
          IS_DIANPING = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant12 = Drip.constant) === null || _Drip$constant12 === void 0 ? void 0 : (_Drip$constant12$uaIn = _Drip$constant12.uaInfo) === null || _Drip$constant12$uaIn === void 0 ? void 0 : _Drip$constant12$uaIn.IS_DIANPING) || false;
          needRunABTest = IS_MEITUAN || IS_MAOYAN || IS_DIANPING;
          if (needRunABTest) {
            _context7.next = 8;
            break;
          }
          return _context7.abrupt("return", false);
        case 8:
          _context7.prev = 8;
          _context7.next = 11;
          return _getABIdData();
        case 11:
          _yield$_getABIdData3 = _context7.sent;
          olapeId = _yield$_getABIdData3.olapeId;
          layerId = _yield$_getABIdData3.layerId;
          filterId = _yield$_getABIdData3.filterId;
          _context7.next = 17;
          return axios.get("".concat(ajaxPreUrl, "/").concat(url, "?olapeId=").concat(olapeId, "&layerId=").concat(layerId, "&filterId=").concat(filterId), {
            timeout: 3000
          });
        case 17:
          _yield$axios$get3 = _context7.sent;
          code = _yield$axios$get3.code;
          data = _yield$axios$get3.data;
          if (!(code === 200)) {
            _context7.next = 22;
            break;
          }
          return _context7.abrupt("return", data);
        case 22:
          return _context7.abrupt("return", false);
        case 25:
          _context7.prev = 25;
          _context7.t0 = _context7["catch"](8);
          return _context7.abrupt("return", false);
        case 28:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[8, 25]]);
  }));
  return _getABIdDataForLocalPerformancerBehavior.apply(this, arguments);
}